module.exports = __webpack_public_path__ + "static/media/cover-logo.861c67b4.jpg";